export const roles = {
  client: 'client',
  guest: 'guest',
  vendor:'vendor',
  coHost:"co_host",
  staff:"staff"
};
